import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'А если эксперты дадут разные оценки?',
  a: 'Такое случается примерно в 15% случаев. Если выводы двух экспертов кардинально расходятся, мы бесплатно привлекаем третьего специалиста (как правило, более высокой квалификации или с узкой специализацией), чтобы помочь вам разобраться глубже.'
}, {
  q: 'Заменяет ли это очную консультацию врача?',
  a: 'Нет. Это информационно-аналитическая услуга — независимая экспертная оценка медицинских документов. Мы помогаем разобраться в ситуации, понять варианты и сформулировать правильные вопросы. Окончательные клинические решения принимаются вместе с вашим лечащим врачом.'
}, {
  q: 'Какие МРТ подходят? Какого качества?',
  a: 'Нам нужен архив с диска МРТ (формат DICOM). Снимки с телефона или распечатки на плёнке не подходят для точного анализа. Мощность томографа желательно от 1.5 Тесла, давность исследования — не более 3–6 месяцев.'
}, {
  q: 'Можно ли потом задать уточняющие вопросы?',
  a: 'Да, после получения заключения у вас будет возможность задать уточняющие вопросы координатору, который передаст их экспертам. Ответы обычно занимают 1–2 рабочих дня.'
}, {
  q: 'Что если случай слишком сложный?',
  a: 'На этапе передачи материалов наш координатор проводит первичный осмотр документов. Если случай требует очного осмотра или дополнительных исследований, мы сообщим об этом до оплаты.'
}, {
  q: 'Передадите ли мои данные кому-то?',
  a: 'Нет. Мы соблюдаем строгую конфиденциальность. Ваши данные передаются экспертам в обезличенном виде по защищённым каналам связи.'
}, {
  q: 'Через сколько действительно приходит отчёт?',
  a: 'В 95% случаев отчёт готов ровно через 48 часов после согласования и оплаты. Если потребуется третье мнение, срок может увеличиться на 24 часа — мы вас предупредим.'
}, {
  q: 'Что если я уже решился на операцию?',
  a: 'Даже в этом случае независимая оценка поможет подтвердить обоснованность подхода и убедиться, что в клинических рекомендациях для подобных случаев рассматриваются те методы, которые вам предложили.'
}];
export const FAQ = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-beigeLight" data-id="element-80">
      <div className="max-w-3xl mx-auto px-6" data-id="element-81">
        <FadeIn data-id="element-82">
          <h2 className="font-serif text-3xl md:text-4xl text-navy text-center mb-16" data-id="element-83">
            Частые вопросы
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-84">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.05} data-id="element-85">
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-beige transition-colors hover:border-sage/30" data-id="element-86">
                <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus:outline-none" data-id="element-87">
                  <span className="font-medium text-navy text-lg" data-id="element-88">{faq.q}</span>
                  <ChevronDown className={`text-sage transition-transform duration-300 shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-89" />
                </button>
                <AnimatePresence data-id="element-90">
                  {openIdx === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-91">
                      <div className="px-6 pb-6 text-navyLight leading-relaxed" data-id="element-92">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};